import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';

interface WaitingRoomProps {
    onBypass?: () => void;
    onLogout?: () => void;
    userEmail?: string;
    isExternal?: boolean;
    onRefresh?: () => void;
}

const WaitingRoom: React.FC<WaitingRoomProps> = ({ onLogout, userEmail, isExternal, onRefresh }) => {
    const { instance } = useMsal();
    const [isChecking, setIsChecking] = useState(false);

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        } else {
            instance.logoutRedirect({
                postLogoutRedirectUri: window.location.origin
            }).catch(e => console.error(e));
        }
    };

    const handleRefresh = () => {
        setIsChecking(true);
        if (onRefresh) {
            onRefresh();
        } else {
            window.location.reload();
        }
    };

    const isCorporateUser = !isExternal && (userEmail ? userEmail.trim().toLowerCase().endsWith('@ldconstructora.cl') : true);

    return (
        <div 
            className="min-h-screen w-full bg-slate-50 dark:bg-[#0d131b] flex flex-col items-center justify-center p-6 font-display"
            style={{
                paddingTop: "calc(1.5rem + var(--kl-safe-top, env(safe-area-inset-top, 0px)))",
                paddingBottom: "calc(1.5rem + var(--kl-safe-bottom, env(safe-area-inset-bottom, 0px)))"
            }}
        >
            <div className="max-w-md w-full bg-white dark:bg-[#1a2634] rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 sm:p-10 text-center animate-scale-up">
                <div className="w-20 h-20 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-500 mx-auto flex items-center justify-center mb-6 shadow-inner">
                    <span className="material-symbols-outlined text-4xl">hourglass_empty</span>
                </div>
                <h1 className="text-2xl font-black text-slate-800 dark:text-white mb-3">En Sala de Espera</h1>
                <p className="text-slate-500 dark:text-slate-400 text-sm mb-8 leading-relaxed">
                    {isCorporateUser 
                        ? "Hemos verificado tu identidad corporativa exitosamente." 
                        : "Hemos verificado tu correo exitosamente."}
                    {" "}Sin embargo, aún no tienes <strong className="text-slate-700 dark:text-slate-200">Obras asignadas</strong> a tu perfil{userEmail ? ` (${userEmail})` : ''}.
                    <br/><br/>
                    Por favor, contacta a un <strong className="text-slate-700 dark:text-slate-200">Administrador de la Plataforma</strong> para que te asigne a un proyecto y defina tu rol operativo.
                </p>
                
                <div className="space-y-3">
                    <button 
                        onClick={handleRefresh}
                        disabled={isChecking}
                        className="w-full py-4 bg-primary text-white rounded-xl font-bold hover:bg-blue-600 transition-all flex items-center justify-center gap-2 shadow-lg shadow-primary/20 disabled:opacity-50"
                    >
                        <span className={`material-symbols-outlined text-[20px] ${isChecking ? 'animate-spin' : ''}`}>sync</span>
                        {isChecking ? 'Comprobando acceso...' : 'Comprobar si ya fui asignado'}
                    </button>
                    <button 
                        onClick={handleLogout}
                        className="w-full py-3.5 rounded-xl border-2 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-primary transition-all flex items-center justify-center gap-2"
                    >
                        <span className="material-symbols-outlined text-[20px]">logout</span>
                        Cerrar Sesión
                    </button>
                </div>
            </div>
            
            <div className="mt-8 text-center text-xs font-bold text-slate-400 uppercase tracking-widest flex items-center justify-center gap-2">
                <span className="material-symbols-outlined text-[14px]">shield</span>
                K-LyDapp Security
            </div>
        </div>
    );
};

export default WaitingRoom;
